module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pictures"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "lee-panel",
    staticStyle: {
      "backgroundColor": "transparent"
    }
  }, [_c('div', {
    staticClass: "heading primary-text"
  }, [_vm._v("Pictures")])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "backgroundColor": "transparent"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-carousel', {
    attrs: {
      "interval": 3000,
      "type": "card",
      "height": "300px"
    }
  }, _vm._l((_vm.pictures), function(item) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "width": "100%",
        "height": "100%"
      }
    })])
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('div', {
    staticClass: "block pagination",
    staticStyle: {
      "padding": "10px",
      "text-align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [8, 16, 24, 32],
      "page-size": _vm.perPage,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.card_list.length
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _vm._l((_vm.showCardList), function(card, index) {
    return _c('el-col', {
      key: card.id,
      attrs: {
        "sm": 12,
        "md": 6
      }
    }, [_c('picture-card', {
      attrs: {
        "name": card.name,
        "url": card.url,
        "description": card.description,
        "id": card.id,
        "views": card.views,
        "comments": card.comments
      },
      on: {
        "remove": function($event) {
          _vm.removeItem(card)
        }
      }
    })], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-804d21b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Picture.vue
// module id = 606
// module chunks = 1